var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_3316_25268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2685 6.88826C12.6756 6.75256 12.8792 6.6847 13.0146 6.73297C13.1324 6.77498 13.2251 6.86768 13.2671 6.98548C13.3153 7.12085 13.2475 7.32441 13.1118 7.73154L11.8722 11.4504C11.8335 11.5663 11.8142 11.6243 11.7812 11.6725C11.7521 11.7151 11.7152 11.752 11.6726 11.7811C11.6244 11.8141 11.5665 11.8334 11.4505 11.872L7.73166 13.1117C7.32454 13.2474 7.12098 13.3152 6.98561 13.2669C6.86781 13.2249 6.7751 13.1322 6.7331 13.0144C6.68482 12.8791 6.75268 12.6755 6.88839 12.2684L8.12801 8.54952C8.16666 8.43357 8.18598 8.3756 8.21891 8.32745C8.24808 8.28481 8.28493 8.24796 8.32757 8.21879C8.37572 8.18586 8.43369 8.16653 8.54964 8.12788L12.2685 6.88826Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3316_25268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassOutlined);
export default __webpack_public_path__ + "static/media/compass-outlined.903b26b62b835470aca05b1c47e5bd7e.svg";
export { ForwardRef as ReactComponent };